<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="资格认证"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <a-row class="row-container">
      <a-col :span="12">
        姓名：{{ data.user_realname }}
      </a-col>
      <a-col :span="12">
        手机号：{{ data.mobile }}
      </a-col>
      <a-col :span="12">
        性别：{{ data.sex }}
      </a-col>
      <a-col :span="12">
        医院：{{ data.hospital }}
      </a-col>
      <a-col :span="12">
        科室：{{ data.department_name }}
      </a-col>
      <a-col :span="12">
        职称：{{ data.professional_name }}
      </a-col>
      <a-col
        v-show="data.qualification_type===1"
        :span="12"
      >
        胸牌：
        <img
          :src="data.qualifications_url"
          class="img-style"
          @click="handlePreview(data.qualifications_url)"
        >
      </a-col>
      <a-col
        v-show="data.qualification_type===2"
        :span="12"
      >
        医师资格证：
        <img
          :src="data.qualifications_url"
          class="img-style"
          @click="handlePreview(data.qualifications_url)"
        >
        <img
          :src="data.qualifications_two_url"
          class="img-style"
          @click="handlePreview(data.qualifications_two_url)"
        >
      </a-col>
      <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancelPreview"
      >
        <img
          alt="资格证"
          style="width: 100%"
          :src="previewImage"
        >
      </a-modal>
    </a-row>
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #check_status>
        <a-radio-group
          v-decorator="['check_status',{rules: [
            { required: true, message: '请选择' },
          ],initialValue:4}]"
          @change="changeRadio"
        >
          <a-radio :value="4">
            同意
          </a-radio>
          <a-radio :value="3">
            不同意
          </a-radio>
        </a-radio-group>
      </template>
      <template
        #reasons
      >
        <a-textarea
          v-decorator="['reasons',{rules: [
            { required: true, message: '请输入不同意的原因' },
          ],}]"
          placeholder="请输入不同意的原因"
          :row="2"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import {
  approveFormData1, approveFormData2,
} from '../data/index';
export default{
  props: ['data', 'visible', 'btnIsLoading'],
  data(){
    return{
      formData: approveFormData1,
      previewVisible: false,
      previewImage: '',
    };
  },
  methods: {
    // 预览
    handlePreview(val){
      this.previewImage=val;
      this.previewVisible=true;
    },
    // 关闭预览
    handleCancelPreview(){
      this.previewVisible=false;
    },
    // 选择
    changeRadio(e){
      if(e.target.value===4){
        this.formData= approveFormData1;
      }
      if(e.target.value===3){
        this.formData= approveFormData2;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.row-container{
  margin-bottom:20px;
  .ant-col-12{
    margin-bottom: 10px;
  }
  .img-style{
    width:80px;
    height:80px;
    margin-right: 10px;
    cursor: pointer;
  }
}
</style>